/* import __COLOCATED_TEMPLATE__ from './add-pm-participants.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./add-pm-participants.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());